/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Material_Section_Behaviour_HintInputs */

const vi_packaging_material_section_behaviour_hint = /** @type {(inputs: Packaging_Material_Section_Behaviour_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai lựa chọn dưới đây quyết định kho trừ hàng lúc nào. Kiểm tra kỹ trước khi lưu.`)
};

/**

* @param {Packaging_Material_Section_Behaviour_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_material_section_behaviour_hint = /** @type {((inputs?: Packaging_Material_Section_Behaviour_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Material_Section_Behaviour_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_material_section_behaviour_hint(inputs)
});